import React, { useState, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { addWallet } from '../../api/profile';
import { Button } from '../common/Button';
import { AuthContext } from '../../context/AuthContext';
import LoadingSpinner from '../common/Loader';

const WalletCreationScreen = () => {
  const navigate = useNavigate();
  const { user } = useContext(AuthContext);
  const [currency, setCurrency] = useState('USD');
  const [isLoading, setIsLoading] = useState(false); // Loading state

  const handleSubmit = async () => {
    if (!user) {
      alert('User not authenticated. Please log in.');
      return;
    }

    setIsLoading(true); // Start loading

    // Generate wallet number starting with 'W' and a random number
    const walletNumber = `W${Math.floor(Math.random() * 1000000)}`;

    const walletData = {
      userId: user.user_id,
      wallet_number: walletNumber,
      currency,
      balance: 0.0,
    };

    try {
      const response = await addWallet(walletData);
      if (!response.error) {
        // Navigate to dashboard with success message
        navigate('/dashboard', { state: { message: 'Wallet created successfully!', isSuccess: true } });
      } else {
        // Navigate to dashboard with error message
        navigate('/dashboard', { state: { message: 'Failed to create wallet. Please try again.', isSuccess: false } });
      }
    } catch (error) {
      console.error('Error creating wallet:', error);
      // Navigate to dashboard with error message
      navigate('/dashboard', { state: { message: 'An error occurred while creating the wallet.', isSuccess: false } });
    } finally {
      setIsLoading(false); // Stop loading
    }
  };

  return (
     
    <div className="flex justify-center items-center min-h-screen bg-gray-100">
      {isLoading && <LoadingSpinner />}
      <div className="bg-white p-8 rounded-lg shadow-lg w-full max-w-md relative">
        <h1 className="text-2xl font-bold mb-6 text-center">Create Wallet</h1>

        {/* Currency Selection */}
        <div className="mb-6">
          <label className="block text-sm font-medium text-gray-700 mb-2">Currency</label>
          <select
            value={currency}
            onChange={(e) => setCurrency(e.target.value)}
            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
          >
            <option value="USD">USD</option>
            <option value="EUR">EUR</option>
            <option value="GBP">GBP</option>
            <option value="JPY">JPY</option>
          </select>
        </div>

        {/* Submit Button */}
        <Button onClick={handleSubmit} className="w-full" disabled={isLoading}>
          Create Wallet
        </Button>
      </div>
    </div>
  );
};

export default WalletCreationScreen;